export function CheckPermission(permission) {
    let list_permission = localStorage.getItem('permission')
    if (list_permission.indexOf(permission) == -1) {
        return false
    } else {
        return true
    }

}